import DashboardIcon from 'components/shared/icons/Dashboard';
import UsersIcon from 'components/shared/icons/Users';
import OrdersIcon from 'components/shared/icons/Orders';
import ToolsIcon from 'components/shared/icons/Tools';
import Service from 'components/shared/icons/Service';
import Calendar from 'components/shared/icons/Calendar';
import Personnel from 'components/shared/icons/Personnel';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import Product from 'components/shared/icons/Products';
import StarIcon from '@mui/icons-material/Star';
import { LocalOffer } from '@mui/icons-material';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import ScheduleIcon from '@material-ui/icons/Schedule';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import DescriptionIcon from '@material-ui/icons/Description';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import ReceiptIcon from '@material-ui/icons/Receipt';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';

const navIcons = {
  مشتریان: <UsersIcon />,
  'فاکتور ها': <OrdersIcon />,
  تنظیمات: <DashboardIcon />,
  'هزینه ها': <MonetizationOnIcon />,
  'ابزار ها': <ToolsIcon />,
  پرسنل: <Personnel />,
  خدمات: <Service />,
  محصولات: <Product />,
  'نوبت دهی': <Calendar />,
  'کد تخفیف': <LocalOffer />,
  بلاگر: <StarIcon />,
  رزرو: <Calendar />,
  انبارگردانی: <Inventory2Icon />,
  'فاکتورهای در انتظار پرداخت': <ScheduleIcon />,
  'بدهی‌های واریز به حساب': <AccountBalanceWalletIcon />,
  'فاکتورهای تجمیعی': <DescriptionIcon />,
  'صندوق اسکناس': <LocalAtmIcon />,
  'عملیات فاکتور': <ReceiptIcon />,
  'سیمی کتاب': <MenuBookIcon />,
  'سفارش‌های آنلاین': <ShoppingCartIcon />,
  'تغییر گروهی قیمت': <TrendingUpIcon />,
  'مسابقه معرفی دوستان': <EmojiEventsIcon />,
  'پایش قیمت پاپکو': <NotificationsActiveIcon />,
};

export default navIcons;
